<template>
  <v-select
    class="pt-1"
    :value="value"
    :items="items"
    :label="label"
    :loading="loading"
    :hint="items.length + ' available · leave blank to apply to all'"
    persistent-hint
    outlined
    clearable
    dense
    multiple
    chips
    small-chips
    @change="$emit('input', $event || [])"
  >
    <template v-slot:prepend-item>
      <v-list-item ripple @mousedown.prevent @click="toggleSelectAll">
        <v-list-item-action>
          <v-icon :color="value.length ? 'primary' : ''">{{ selectAllIcon }}</v-icon>
        </v-list-item-action>
        <v-list-item-content><v-list-item-title>Select all</v-list-item-title></v-list-item-content>
      </v-list-item>
      <v-divider class="mt-2"></v-divider>
    </template>
  </v-select>
</template>
<script>
export default {
  name: 'HierarchyFilterSelect',
  props: {
    value: { type: Array, default: () => [] },
    items: { type: Array, default: () => [] },
    label: { type: String, default: '' },
    loading: { type: Boolean, default: false }
  },
  computed: {
    isAllSelected() {
      return this.items.length > 0 && this.items.every(i => this.value.includes(i))
    },
    selectAllIcon() {
      if (this.isAllSelected) return 'mdi-close-box'
      return this.value.length ? 'mdi-minus-box' : 'mdi-checkbox-blank-outline'
    }
  },
  methods: {
    toggleSelectAll() {
      this.$emit('input', this.isAllSelected ? [] : [...this.items])
    }
  }
}
</script>
